import { SORT_TYPE } from "../../types/enum";

/**
 * 정렬 타입을 현재 언어에 맞는 텍스트로 변환하는 함수
 */
export function getSortTypeText(sortType: SORT_TYPE, t: any): string {
  switch (sortType) {
    case SORT_TYPE.RECENT:
      return t("sort.newest");
    case SORT_TYPE.OLDEST:
      return t("sort.oldest");
    default:
      return sortType;
  }
}

/**
 * 모든 정렬 타입 옵션을 현재 언어에 맞는 텍스트로 변환하는 함수
 */
export function getSortTypeOptions(
  t: any,
): Array<{ key: SORT_TYPE; text: string }> {
  return [
    { key: SORT_TYPE.RECENT, text: t("sort.newest") },
    { key: SORT_TYPE.OLDEST, text: t("sort.oldest") },
  ];
}
